import { TranslateModule } from '../../../../shared/translate/translate.module';
import { FireUserComponent } from './fire-user.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [FireUserComponent],
  imports: [
    CommonModule, TranslateModule, IonicModule,
    FormsModule,
  ],
  exports: [FireUserComponent]
})
export class FireUserModule { }
